var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUniversalSearchClose = function SvgUniversalSearchClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.145 13.853a.5.5 0 0 0 .708 0L6.998 7.71l6.148 6.144a.5.5 0 0 0 .707-.707L7.706 7 13.85.854a.5.5 0 1 0-.708-.707L6.998 6.294.85.149a.5.5 0 0 0-.705.705l6.146 6.147-6.146 6.147a.5.5 0 0 0 0 .705Z",
    fill: "#000",
    fillRule: "nonzero"
  })));
};
export default SvgUniversalSearchClose;